import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';
import {AccessUserInfo} from '../models/user/UserInfo'
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(private authService: AuthService,private router: Router,) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isLoggedIn()) 
    {
      
      let userInfo = AccessUserInfo.getUserInfo();
      let bartRoleCode:string;
      if(userInfo!=null){bartRoleCode=userInfo.bartRoleCode}
      if (route.data.roles && route.data.roles.indexOf(bartRoleCode) === -1 && route.data.roles.indexOf('*')===-1) {
        // role not authorised so redirect to default page
        this.router.navigate(['/reports']);
        return false;
      }
      return true;
    }
  
    this.authService.startAuthentication();
    return false;
  }
}
